// extracted by mini-css-extract-plugin
export default {"wrapper":"aErNbV","img-container":"xkBM1I","small-img":"_lZWLk","img-styled":"vdjSR7","swiper":"TVFg9K","with-cursor":"SAA_Yz"};